import Vue from 'vue'
import VueRouter from 'vue-router'
import { routes as dashboardRoutes } from '@/dashboard/route'
import { routes as authRoutes } from '@/auth/route'
import { routes as userRoutes } from '@/users/route'
import { routes as messageRoutes } from '@/messages/route'
import { routes as webhookRoutes } from '@/webhooks/route'
import { routes as brazeWebhookRoutes } from '@/braze/route'
import { routes as blacklistRoutes } from '@/blacklists/route'

Vue.use(VueRouter)

const routes = [
    ...dashboardRoutes,
    ...authRoutes,
    ...userRoutes,
    ...messageRoutes,
    ...webhookRoutes,
    ...brazeWebhookRoutes,
    ...blacklistRoutes
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
